export default __webpack_public_path__ + "static/media/Initiate's Gloves of Twining Smoke.cdad4041.jpg";